<template>
  <div>
      <nav class="bar bar-nav">
        <a class="button button-link button-nav pull-left"  @click="tolast()">
          <span class="icon icon-left"></span>返回
        </a>
        <div class="button button-link button-nav pull-right" >
          <!--<a href="http://genechem-customer.xinfuli.net/web/login">积分兑换 </a>-->
        </div>
      </nav>

    <div class="content" style="margin-bottom: 3rem">
      <div style="text-align: center;font-size: larger" v-if="VipPlanList.manageCustomerPlans && VipPlanList.manageCustomerPlans.length > 0 ">我管理的大客户计划</div>
      <div class="list-block cards-list" v-for="plan in VipPlanList.manageCustomerPlans" style="margin-top: 30px"  >
        <ul  @click="gotovipdetails(plan)">
          <li class="card">
            <div class="card-header" style="font-size: smaller">
              <span>名称- {{plan.customerPlanName}}</span>
              <span>类型- <span v-if="plan.type === 2">
                储值账户
              </span>
                 <span v-else>
                VIP账户
              </span>
              </span>
            </div>
            <div class="card-content">
              <div class="card-content-inner" style="margin-bottom: 25px">
                <div>
                  <div style="float: left">
                    等级-- VIP{{plan.VIPLevel}}
                  </div>
                  <div style="float: right;">
                    单位-- {{plan.enterpriseName}}
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer" style="font-size: smaller">
              <span>
                生效时间- {{plan.startDt}}
              </span>
              <span>
               有效截止时间- {{plan.validDt}}
              </span>
            </div>
            <!--<div class="card-footer" style="font-size: smaller">-->
              <!--<span>-->
                <!--赠送名额： {{plan.applicationNumber}}个-->
              <!--</span>-->
            <!--</div>-->
          </li>
        </ul>
      </div>
      <div style="text-align: center;font-size: larger"
           v-if="VipPlanList.ubietyCustomerPlans && VipPlanList.ubietyCustomerPlans.length > 0">我所属的大客户计划
      </div>
      <div class="list-block cards-list" v-for="plan in VipPlanList.ubietyCustomerPlans " style="margin-top: 30px">

        <ul >
          <li class="card">
            <div class="card-header" style="font-size: smaller">
              <span>名称- {{plan.customerPlanName}}</span>
              <span>类型- <span v-if="plan.type === 2">
                储值账户
              </span>
                 <span v-else>
                VIP账户
              </span>
              </span>
            </div>
            <div class="card-content">
              <div class="card-content-inner" style="margin-bottom: 25px">
                <div>
                  <div style="float: left">
                    等级-- VIP{{plan.VIPLevel}}
                  </div>
                  <div style="float: right;">
                    单位-- {{plan.enterpriseName}}
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer" style="font-size: smaller">
              <span>
                生效时间- {{plan.startDt}}
              </span>
              <span>
               有效截止时间- {{plan.validDt}}
              </span>
            </div>
            <!--<div class="card-footer" style="font-size: smaller">-->
              <!--<span>-->
                <!--赠送名额： {{plan.applicationNumber}}个-->
              <!--</span>-->
            <!--</div>-->
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>


<script>
//  import $ from 'jquery'
  import {mapState} from 'vuex'
  export default {
    mounted () {
    },
    created () {
      this.fetchData()
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ])
    },
    data () {
      return {
        VipPlanList: []
      }
    },
    methods: {
      fetchData () {
//        var param = {
//          'CustomerNo': this.sessionInfo.customerInfo.customerNo
//        }
        var param = {
          'CustomerNo': this.sessionInfo.customerInfo.customerNo
        }
        this.VipPlanList = []
        this.gcapi('retrieveCustomerPlan', param).then((response) => {
          this.VipPlanList = response.body.result
          console.log(this.VipPlanList)
        })
      },
      tolast () {
        this.$router.push({name: 'me'})
      },
      gotovipdetails (plan) {
        this.$router.push({path: 'VipPlanMemberDetails', query: {plan: plan, VipPlanList: this.VipPlanList}})
      }
    }
  }
</script>


<style scoped>
  .item-inner {
    padding-bottom: 0rem
  }
</style>



// WEBPACK FOOTER //
// VipPlanDetails.vue?ee6aa808